/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:38
 */
import { Post, Get, Patch, Put, Delete, Download, ax, Import } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace MinIO {
    /**
     *  获取本地存储文件访问url
     */
    export var PresignedGetObject = (data): Promise<any> => {
        return Get(`/msls/MinIO/PresignedGetObject?${qs.stringify(data)}`, '');
    };
}
